import { useEffect } from 'react';

export default function MatomoDelegate({ root = document }) {
  useEffect(() => {
    if (!root) return undefined;

    function handleClick(e) {
      // 1) find actionable element (closest with data-mtm-action)
      const el = e.target && e.target.closest && e.target.closest('[data-mtm-action]');
      if (!el) return;

      // 2) read dataset
      const dataset = el.dataset;
      const eventName = dataset.mtmEvent || dataset.mtmAction || 'click';
      const payload = {
        event: eventName,
        category: dataset.mtmCategory || 'UI',
        action: dataset.mtmAction || eventName,
        name: dataset.mtmName,
        value: dataset.mtmValue ? Number(dataset.mtmValue) : undefined,
      };

      try {
        // 3) quick, non-blocking pushes
        if (window._mtm) {
          window._mtm.push(payload);
        }

        if (window._paq) {
          // build args minimal and push
          const args = ['trackEvent', payload.category, payload.action];
          if (payload.name) args.push(payload.name);
          if (payload.value !== undefined) args.push(payload.value);
          // use setTimeout to avoid blocking UI thread if extremely busy
          window._paq.push(args);
        }
      } catch (err) {
        // swallow analytics errors — never break app
        // optionally send to console in dev
        if (process.env.NODE_ENV === 'development') console.warn('MtmDelegate push failed', err);
      }
    }

    // 4) attach single delegated listener
    root.addEventListener('click', handleClick, false);

    return () => {
      root.removeEventListener('click', handleClick, false);
    };
  }, [root]);

  return null;
}
